// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__2Xcc5","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__36ney"};